import { ensure } from 'buzz_lib_shared';
export const getAuthConfig = () => {
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const authority = process.env.REACT_APP_AUTHORITY;
  const knownAuthority1 = process.env.REACT_APP_KNOWN_AUTHORITY_1;
  const policySignUpIn = process.env.REACT_APP_POLICY_SIGN_UP_IN;
  const policyPasswordReset = process.env.REACT_APP_POLICY_PASSWORD_RESET;
  const graphScope = process.env.REACT_APP_GRAPH_SCOPE;
  const clientCredentialsFlowApiScope = process.env.REACT_APP_CLIENT_CREDENTIALS_FLOW_API_SCOPE;
  const buzzAuthEndpoint = process.env.REACT_APP_BUZZ_AUTH_ENDPOINT;
  ensure(clientId, 'REACT_APP_CLIENT_ID environment variable is not set');
  ensure(authority, 'REACT_APP_AUTHORITY environment variable is not set');
  ensure(knownAuthority1, 'REACT_APP_KNOWN_AUTHORITY_1 environment variable is not set');
  ensure(policySignUpIn, 'REACT_APP_POLICY_SIGN_UP_IN environment variable is not set');
  ensure(policyPasswordReset, 'REACT_APP_POLICY_PASSWORD_RESET environment variable is not set');
  ensure(graphScope, 'REACT_APP_GRAPH_SCOPE environment variable is not set');
  ensure(clientCredentialsFlowApiScope, 'REACT_APP_CLIENT_CREDENTIALS_FLOW_API_SCOPE environment variable is not set');
  ensure(buzzAuthEndpoint, 'REACT_APP_BUZZ_AUTH_ENDPOINT environment variable is not set');
  const baseAuthority = authority.endsWith('/') ? authority.slice(0, -1) : authority;
  const authConfig = {
    clientId,
    authority: "".concat(baseAuthority, "/").concat(policySignUpIn),
    knownAuthorities: [knownAuthority1],
    passwordResetAuthority: "".concat(baseAuthority, "/").concat(policyPasswordReset),
    graphScope: graphScope,
    clientCredentialsFlowScope: clientCredentialsFlowApiScope,
    buzzAuthEndpoint: buzzAuthEndpoint
  };
  return authConfig;
};